var render, staticRenderFns
import script from "./QcPieChart.vue?vue&type=script&lang=js"
export * from "./QcPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "925bbc30",
  null
  
)

export default component.exports